// src/pages/Contact.js

import React from 'react';
import { Helmet } from 'react-helmet-async';

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

// Page Component
import ContactComponent from './PageComponent/ContactComponent';

function Contact() {
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Connect to our consultant now for your Blinds requirements</title>
        <meta
          name="description"
          content="Create customized blinds as per your desire & Interior Design demands. Contact now for wide range of design, texture, visibility and openness"
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/contact/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Contact" />
        <meta
          property="og:description"
          content="Create customized blinds as per your desire & Interior Design demands. Contact now for wide range of design, texture, visibility and openness"
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/contact/`} />
        <meta property="og:site_name" content="Callistus Blinds" />
      </Helmet>

      <div>
        <Navbar />
        <NotificationBar />
        <ContactComponent />
        <Footer />
      </div>
    </>
  );
}

export default Contact;